export class commonmodel {
    datetimeformat : 'YYYY/MM/DD HH24:MI:SS'
    lan: 'en';    
    clientId : number = 0;
    userId:number = 0;
    loginUserName:string= '';
    RecordChange :string;
    masterrole : string = '';
}

